import '@helloself/hello-self-ui/style.css';
import '@helloself/hello-self-ui/fonts.css';
import './assets/scss/app.scss';
import 'react-loading-skeleton/dist/skeleton.css';

import { DefaultTheme, GlobalFonts } from '@helloself/hello-self-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { AmplitudeProvider } from './analytics/amplitude/amplitudeProvider';
import App from './App';
import { store } from './app/store';
import amplify from './config/amplify';
import { registerChunkLoadRecovery } from './chunkLoadRecovery';
import { datadogSetup } from './datadogSetup';
import { handleAppCrash } from './errorHandling';
import CrashFallback from './ui/CrashFallback';

amplify();
datadogSetup();
registerChunkLoadRecovery();

const homepage_prefix = import.meta.env.VITE_HOMEPAGE ? `/${import.meta.env.VITE_HOMEPAGE}/` : '/partners/';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <ErrorBoundary FallbackComponent={CrashFallback} onError={handleAppCrash}>
                <AmplitudeProvider>
                    <ThemeProvider theme={DefaultTheme}>
                        <Provider store={store}>
                            <BrowserRouter basename={homepage_prefix}>
                                <GlobalFonts />
                                <Route path="/" component={App} />
                            </BrowserRouter>
                        </Provider>
                    </ThemeProvider>
                </AmplitudeProvider>
            </ErrorBoundary>
        </React.StrictMode>
    );
}
